import type { TextFieldProps } from "@mui/material/TextField";

import { TextField } from "src/components/Default/LekUI/TextField";

export const TextArea = (props: TextFieldProps) => {
	return <TextField {...props} />;
};
